// src/color/convert.ts
function convertColor(input, alpha = 1, inputFormat) {
  if (alpha > 1 || alpha < 0) {
    throw new Error("Invalid alpha value");
  }
  let red;
  let green;
  let blue;
  switch (inputFormat) {
    case "hex":
      red = parseInt(input.slice(1, 3), 16);
      green = parseInt(input.slice(3, 5), 16);
      blue = parseInt(input.slice(5, 7), 16);
      break;
    default:
      throw new Error("Invalid input format");
  }
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
function hexToRGBA(input, alpha = 1) {
  return convertColor(input, alpha, "hex");
}
export {
  hexToRGBA
};
